
import { ReservationItemModule } from '@/store/modules/reservationItem';
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import moment from 'moment';

@Component({
  components: {
  },
})

export default class extends Vue {
  get formData() {
    return ReservationItemModule.form;
  }

  set formData(val: any) {
    ReservationItemModule.setForm(val);
  }

  get scheduleType() {
    return ReservationItemModule.scheduleType;
  }

  get isNew() {
    return ReservationItemModule.isNew;
  }

  private form = {
    date: '',
  }

  private pickerOptions = {
    disabledDate(time: any) {
      return moment(time).format('YYYY-MM-DD') < moment(ReservationItemModule.form.possiableUpdateDate).format('YYYY-MM-DD');
    },
  }

  private close() {
    this.$emit('close');
  }

  private add() {
    const reservationItemDay = { ...this.formData.reservationItemDay };
    delete reservationItemDay.uid;
    if (this.scheduleType === null) {
      this.formData.updateSchedule.push({
        addStatus: !this.isNew,
        updateDate: this.form.date,
        reservationItemDay: { ...reservationItemDay },
        itemHour: [...this.formData.itemHour],
      });
    } else {
      this.formData.schedulePart[Number(this.scheduleType)].updateSchedule.push({
        addStatus: !this.isNew,
        updateDate: this.form.date,
        reservationItemDay: { ...this.formData.reservationItemDay },
        itemHour: [...this.formData.itemHour],
      });
    }
    this.close();
  }
}
